var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.modes),function(optionMode){return _c('div',{key:optionMode,staticClass:"o-primary-btn c-autobuyer-box__mode-select l-autobuyer-choice",attrs:{"value":optionMode},on:{"click":function($event){return _vm.changeMode(optionMode)}}},[_vm._v(" "+_vm._s(_vm.modeNameFn(optionMode))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }